<!-- 校友资源页面 -->
<template>
  <div>
    <div class="alumniResourcesDiv">
      <div class="searchDiv clearfix">
        <div class="resourcesDiv">
          <!-- 资源弹窗 -->
          <van-cell
            id="resourcesId"
            class="resources"
            @click="showResourcesPopup"
          ></van-cell>
          <van-popup
            round
            v-model="resourceShow"
            position="top"
            :style="{ height: '70%' }"
            class="resourcesPopup"
          >
            <div class="resourcesPopupSeach clearfix">
              <div class="popupResources">资源</div>
              <div class="popupCity" @click="showCityPopup">城市</div>
              <div class="popupSearchDiv">
                <img
                  src="../../assets/image/btn_sousuo_nor.png"
                  alt=""
                  class="searchImg"
                />
              </div>
            </div>
            <div class="popupData clearfix">
              <div class="popupDataResources">
                <div
                  class="industry"
                  v-for="item in industry"
                  :key="item"
                  @click="getIndustry('industry' + item, item)"
                  :id="'industry' + item"
                >
                  {{ item }}
                </div>
              </div>
              <div class="industryNameDiv clearfix">
                <div
                  class="industryName"
                  v-for="index in industryName"
                  :key="index"
                  :id="'industryName' + index"
                  @click="clickIndustryName('industryName' + index, index)"
                >
                  {{ index }}
                </div>
              </div>
            </div>
            <div class="btnDiv clearfix">
              <div class="clear" @click="clearIndustryList">清空</div>
              <button
                class="getAlumniBtn"
                v-if="this.resourceShow == true && this.searchShow == true"
                @click="
                  resourceShow = false;
                  cityShow = false;
                "
              >
                确定
              </button>
              <button class="getAlumniBtn" @click="updataIndustry" v-else>
                查看{{ this.alumnusNum }}位校友资源
              </button>
            </div>
          </van-popup>
          <!-- 资源弹窗结束 -->
        </div>
        <div class="cityDiv">
          <!-- 城市弹窗 -->
          <van-cell id="cityId" class="city" @click="showCityPopup"></van-cell>
          <van-popup
            round
            v-model="cityShow"
            position="top"
            :style="{ height: '70%' }"
            class="resourcesPopup"
          >
            <div class="provincePopupSeach clearfix">
              <div class="provincePopupResources" @click="showResourcesPopup">
                资源
              </div>
              <div class="provincePopupCity">城市</div>
              <!--    <div class="popupSearchDiv">
                <img
                  src="../../assets/image/btn_sousuo_nor.png"
                  alt=""
                  class="searchImg"
                />
              </div> -->
            </div>
            <div class="popupData clearfix">
              <div class="popupDataResources">
                <div
                  class="province"
                  v-for="item in province"
                  :key="item"
                  @click="getCity('provinceId' + item, item)"
                  :id="'provinceId' + item"
                >
                  {{ item }}
                </div>
              </div>
              <div class="cityNameDiv clearfix">
                <div
                  class="cityName"
                  v-for="index in city"
                  :key="index"
                  @click="clickCityName('cityNameId' + index, index)"
                  :id="'cityNameId' + index"
                >
                  {{ index }}
                </div>
              </div>
            </div>
            <div class="btnDiv clearfix">
              <div class="clear" @click="clearCityList">清空</div>
              <button
                class="getAlumniBtn"
                v-if="this.cityShow == true && this.searchShow == true"
                @click="
                  resourceShow = false;
                  cityShow = false;
                "
              >
                确定
              </button>
              <button class="getAlumniBtn" @click="updataIndustry" v-else>
                查看{{ this.alumnusNum }}位校友资源
              </button>
            </div>
          </van-popup>
          <!-- 城市弹窗结束 -->
        </div>
        <!-- <div class="schoolFriends">
          <button class="schoolFriendsBtn">同窗好友</button>
        </div> -->
        <div class="search">
          <!-- 高级搜索 -->

          <van-cell
            id="searchId"
            class="searchPopupDiv"
            @click="showSearchPopup"
          >
            <img
              src="../../assets/image/btn_sousuo_nor.png"
              alt=""
              class="searchImg"
            />
          </van-cell>
          <van-popup
            round
            v-model="searchShow"
            position="right"
            closeable
            :style="{ height: '100%', width: '100%' }"
            class="searchPopup"
          >
            <div class="popSearchDataDiv">
              <div class="popSearchDataResourcesDiv clearfix">
                <div class="popSearchDataResourcesName">资源</div>
                <div class="popSearchDataResourcesNum">
                  <van-badge
                    :content="this.industryNameList.length"
                    max="9"
                    color="#1989fa"
                  >
                  </van-badge>
                </div>
                <div class="arrowResourcesDiv" @click="showResourcesPopup">
                  <van-icon name="arrow" size="2em" color="#999999" />
                </div>
              </div>
              <hr />
              <div class="popSearchDataCityDiv clearfix">
                <div class="popSearchDataCity">城市</div>
                <div class="popSearchDataCityNum">
                  <van-badge
                    :content="this.cityNameList.length"
                    max="9"
                    color="#1989fa"
                  >
                  </van-badge>
                </div>
                <div class="arrowCityDiv" @click="showCityPopup">
                  <van-icon name="arrow" size="2em" color="#999999" />
                </div>
              </div>
              <hr />
              <div class="popSearchData">
                高级搜索
                <el-form
                  label-position="top"
                  label-width="80px"
                  :model="formData"
                  :rules="rules"
                  ref="formData"
                  :hide-required-asterisk="true"
                >
                  <el-form-item label="姓名" prop="name">
                    <el-input
                      class="nameDiv"
                      v-model="formData.name"
                      placeholder="请输入姓名"
                    ></el-input>
                  </el-form-item>
                  <div class="sexSelectDiv">
                    <el-form-item label="性别" prop="sex">
                      <select v-model="formData.sex" class="sexSelect">
                        <option value="" class="formOption">所有</option>
                        <option value="1" class="formOption">男</option>
                        <option value="2" class="formOption">女</option>
                      </select>
                    </el-form-item>
                  </div>
                  <el-form-item label="院系" prop="college">
                    <el-input
                      v-model="formData.college"
                      placeholder="请输入院系"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="专业" prop="major">
                    <el-input
                      v-model="formData.major"
                      placeholder="请输入专业"
                    ></el-input>
                  </el-form-item>
                  <div class="graduationDateDiv">
                    <el-form-item label="学届（毕业年份）" prop="xuejie">
                      <select
                        v-model="formData.xuejie"
                        name=""
                        id=""
                        class="dateSelect"
                      >
                        <option class="formOption" value="">全部</option>
                        <option class="formOption">1996</option>
                        <option class="formOption">1997</option>
                        <option class="formOption">1998</option>
                        <option class="formOption">2020</option>
                      </select>
                    </el-form-item>
                  </div>
                  <div class="educationDiv">
                    <el-form-item label="学历" prop="xueli">
                      <select
                        v-model="formData.xueli"
                        name=""
                        id=""
                        class="educationSelect"
                      >
                        <option value="" class="formOption">全部</option>
                        <option value="专科" class="formOption">专科</option>
                        <option value="本科" class="formOption">本科</option>
                        <option value="研究生" class="formOption">
                          研究生
                        </option>
                        <option value="博士" class="formOption">博士</option>
                      </select>
                    </el-form-item>
                  </div>
                  <el-form-item label="公司名称" prop="danwei	">
                    <el-input
                      v-model="formData.danwei"
                      placeholder="请输入公司名称"
                    ></el-input>
                  </el-form-item>
                  <div class="SearchDataIndustryDiv">
                    <el-form-item label="行业类别" prop="hangye">
                      <select
                        v-model="formData.hangye"
                        name=""
                        id=""
                        class="industrySelect"
                      >
                        <option value="" class="formOption">全部</option>
                        <option
                          v-for="item in industry"
                          :key="item.id"
                          :value="item.name"
                          class="formOption"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </el-form-item>
                  </div>
                  <el-form-item label="兴趣爱好" prop="hobby">
                    <el-input
                      v-model="formData.hobby"
                      placeholder="请输入兴趣爱好"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="searchBtnDiv clearfix">
                <div class="clear" @click="clearFormData">清空</div>
                <button class="getAlumniBtn" @click="getSearch">
                  查看{{ this.alumnusNum }}位校友资源
                </button>
              </div>
            </div>
          </van-popup>
          <!-- 高级搜索结束 -->
        </div>
      </div>
      <!-- 本校校友 大咖 导航 -->
      <div class="alumniDivNav clearfix">
        <div class="ourSchool" id="ourSchoolId" @click="clickGetAlumnus">
          本校校友
        </div>
        <div
          class="otherSchool"
          id="otherSchoolId"
          @click="clickGetOtherAlumnus"
        >
          同城
        </div>
      </div>
      <!-- 校友数据卡片 -->
      <div class="alumniDiv" v-if="isAlumnus == 1">
        <!-- 校友懒加载 -->
        <van-list
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="alumniCard clearfix"
            v-for="item in alumnus"
            :key="item"
            @click="gotoAlumnusList(item.aUserId)"
          >
            <div class="alumniPhotoDiv">
              <img :src="item.aUrl" alt="校友照片" class="alumniPhoto" />
              <div class="sexDiv" v-if="item.asex == 1">
                <img
                  src="../../assets/image/btn_nan_nor.png"
                  alt="性别男"
                  class="sex"
                />
              </div>
              <div class="sexDiv" v-else>
                <img
                  src="../../assets/image/btn_nv_nor.png"
                  alt="性别女"
                  class="sex"
                />
              </div>
              <div class="adress" v-if="item.aCity == myCity">同城</div>
              <div class="adress" v-else>{{ item.aCity }}</div>
            </div>
            <div class="alumniData">
              <div class="alumniName">{{ item.aName }}</div>
              <div class="alumniSchoolAndDissertation">
                {{ item.aCollege }} &nbsp;&nbsp;{{ item.aXuejie }}
              </div>
              <div class="alumniIndustry">从事行业：{{ item.aHangye }}</div>
              <div class="alumniCompany">单位：{{ item.aDanWei }}</div>
              <div class="alumniResources">提供资源：{{ item.aIndustry }}</div>
            </div>
          </div>
        </van-list>
      </div>
      <!-- 大咖列表 -->
      <div class="ohterAlumniDiv" v-else>
        <!-- 校友懒加载 -->
        <div
          class="alumniCard clearfix"
          v-for="item in otherAlumnus"
          :key="item.id"
          @click="gotoAlumnusList(item.aUserId, item.user_id)"
        >
          <div class="alumniPhotoDiv">
            <img :src="item.aUrl" alt="校友片" class="alumniPhoto" />
            <div class="sexDiv" v-if="item.asex == 1">
              <img
                src="../../assets/image/btn_nan_nor.png"
                alt="性别男"
                class="sex"
              />
            </div>
            <div class="sexDiv" v-else>
              <img
                src="../../assets/image/btn_nv_nor.png"
                alt="性别女"
                class="sex"
              />
            </div>
            <div class="adress" v-if="item.aCity == myCity">同城</div>
            <div class="adress" v-else>{{ item.aCity }}</div>
          </div>
          <div class="alumniData">
            <div class="alumniName">{{ item.aName }}</div>
            <div class="alumniSchoolAndDissertation">
              {{ item.aCollege }} &nbsp;&nbsp;{{ item.aXuejie }}
            </div>
            <div class="alumniIndustry">从事行业：{{ item.aHangye }}</div>
            <div class="alumniCompany">单位：{{ item.aDanWei }}</div>
            <div class="alumniResources">提供资源：{{ item.aIndustry }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Base64 from "@/utils/base64";
export default {
  data() {
    return {
      postOtherAlumnus: {
        name: "",
        industry: "",
        city: "",
        sex: "",
        college: "",
        major: "",
        xuejie: "",
        xueli: "",
        danwei: "",
        hangye: "",
        hobby: "",
        userId: window.localStorage.getItem("user_id"),
        currentPage: 1,
        perPage: 100,
        bigShot: 0,
      },
      alumnus: [],
      otherAlumnus: [],
      alumnusList: "",
      resourceShow: false,
      cityShow: false,
      searchShow: false,
      show: false,
      industry: [],
      industryName: [],
      alumnusNum: "",
      // 发送的数据，行业列表数据
      industryNameList: [],
      // 发送的数据，市列表数据
      cityNameList: [],
      province: [],
      city: [],
      formData: {
        name: "",
        industry: "",
        city: "",
        sex: "",
        college: "",
        major: "",
        xuejie: "",
        xueli: "",
        danwei: "",
        hangye: "",
        hobby: "",
        userId: window.localStorage.getItem("user_id"),
        currentPage: 1,
        perPage: 5,
        bigShot: 0,
      },
      loading: false,
      finished: false,
      alumnusLastPage: "",
      myCity: "",
      // 判断是本校还是大咖 ,1 是本校2是大咖
      isAlumnus: 1,
      rules: {
        rname: [
          // { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        /* sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        college: [{ required: true, message: "请输入院系", trigger: "blur" }],
        major: [{ required: true, message: "请输入专业", trigger: "blur" }],
        xuejie: [
          { required: true, message: "请选择学届", trigger: "change" },
        ],
        xueli: [
          { required: true, message: "请选择学历", trigger: "change" },
        ],
        danwei	: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        hangye: [
          { required: true, message: "请选择行业类别", trigger: "change" },
        ],
        hobby: [{ required: true, message: "请输入兴趣爱好", trigger: "blur" }], */
      },
    };
  },
  created() {
    this.clickGetAlumnus();
    this.getProvince();
    this.getMyCity();
  },
  methods: {
    // 点击请求校友列表
    async clickGetAlumnus() {
      if (this.alumnus != []) {
        this.alumnus = [];
        this.formData.currentPage = 1;
        this.loading = false;
        this.finished = false;
      }
      this.isAlumnus = 1;
      const result = await this.$http.get(
        "/amresources/getAlumniInDetailList",
        {
          params: {
            city: this.cityNameList.toString(),
            industry: this.industryNameList.toString(),
            name: this.formData.name,
            sex: this.formData.sex,
            college: this.formData.college,
            major: this.formData.major,
            xuejie: this.formData.xuejie,
            xueli: this.formData.xueli,
            danwei: this.formData.danwei,
            hangye: this.formData.hangye,
            hobby: this.formData.hobby,
            userId: this.formData.userId,
            currentPage: 1,
            perPage: 5,
            bigShot: 0,
          },
        }
      );
      for (let i = 0; i < result.data.list.length; i++) {
        this.alumnus.push(result.data.list[i]);
      }
      this.alumnusNum = result.data.total;
      this.alumnusLastPage = result.data.lastPage;
      document.getElementById("otherSchoolId").style.backgroundColor =
        "#DFDFDF";
      document.getElementById("otherSchoolId").style.color = "#999999";
      document.getElementById("ourSchoolId").style.backgroundColor = "#00706E";
      document.getElementById("ourSchoolId").style.color = "white";
    },
    async getAlumnus() {
      const result = await this.$http.get(
        "/amresources/getAlumniInDetailList",
        {
          params: {
            city: this.cityNameList.toString(),
            industry: this.industryNameList.toString(),
            name: this.formData.name,
            sex: this.formData.sex,
            college: this.formData.college,
            major: this.formData.major,
            xuejie: this.formData.xuejie,
            xueli: this.formData.xueli,
            danwei: this.formData.danwei,
            hangye: this.formData.hangye,
            hobby: this.formData.hobby,
            userId: this.formData.userId,
            currentPage: this.formData.currentPage,
            perPage: 5,
            bigShot: 0,
          },
        }
      );
      for (let i = 0; i < result.data.list.length; i++) {
        this.alumnus.push(result.data.list[i]);
      }
      this.alumnusNum = result.data.total;
      this.alumnusLastPage = result.data.lastPage;
    },
    // 点击大咖请求
    async clickGetOtherAlumnus() {
      this.postOtherAlumnus.city = this.myCity;
      if (this.otherAlumnus != []) {
        this.otherAlumnus = [];
        this.postOtherAlumnus.page = 1;
        this.otherLoading = false;
        this.otherFinished = false;
      }
      this.isAlumnus = 2;
      const result = await this.$http.get(
        "/amresources/getAlumniInDetailList",
        {
          params: this.postOtherAlumnus,
        }
      );
      for (let i = 0; i < result.data.list.length; i++) {
        this.otherAlumnus.push(result.data.list[i]);
      }
      this.alumnusNum = result.data.total;
      this.alumnusLastPage = result.data.lastPage;
      document.getElementById("otherSchoolId").style.backgroundColor =
        "#00706E";
      document.getElementById("otherSchoolId").style.color = "white";
      document.getElementById("ourSchoolId").style.backgroundColor = "#dfdfdf";
      document.getElementById("ourSchoolId").style.color = "#999999";
    },
    showResourcesPopup() {
      this.getPopupResources();
      this.resourceShow = true;
      this.cityShow = false;
      document.getElementById("resourcesId").style.color = "#00706E";
    },
    // 资源弹窗的1级请求
    async getPopupResources() {
      const result = await this.$http.get("/amresources/getIndustryLevelList");
      this.industry = result.data.IndustryLevelList;
    },
    // 资源弹窗的2级请求
    async getIndustry(item, name) {
      const result = await this.$http.get("/amresources/getIndustryList", {
        params: { industryLevel: item.substr(8) },
      });
      this.industryName = result.data.IndustryList;
      const changeColor = document.getElementsByClassName("industry");
      for (let i = 0; i < changeColor.length; i++) {
        changeColor[i].style.color = "#333333";
      }
      document.getElementById(item).style.color = "#00706E";
    },
    clickIndustryName(index, name) {
      if (document.getElementById(index).style.color === "rgb(57, 135, 251)") {
        document.getElementById(index).style.color = "#333333";
        document.getElementById(index).style.borderColor = "#bfbfbf";
        for (let i = 0; i < this.industryName.length; i++) {
          if (this.industryNameList[i] === name) {
            this.industryNameList.splice(i, 1);
            i--;
            console.log(this.industryNameList);
            this.clickAndGetIndustryName();
          }
        }
      } else {
        this.industryNameList.push(name);
        console.log(this.industryNameList);
        this.clickAndGetIndustryName();
        document.getElementById(index).style.color = "#00706E";
        document.getElementById(index).style.borderColor = "#00706E";
      }
    },
    async clickAndGetIndustryName() {
      const result = await this.$http.get(
        "/amresources/getAlumniInDetailList",
        {
          params: {
            city: this.cityNameList.toString(),
            industry: this.industryNameList.toString(),
            name: this.formData.name,
            sex: this.formData.sex,
            college: this.formData.college,
            major: this.formData.major,
            xuejie: this.formData.xuejie,
            xueli: this.formData.xueli,
            danwei: this.formData.danwei,
            hangye: this.formData.hangye,
            hobby: this.formData.hobby,
            userId: this.formData.userId,
            currentPage: 1,
            perPage: 5,
            bigShot: 0,
          },
        }
      );
      this.alumnusNum = result.data.list.length;
      this.alumnusList = result.data.list;
    },
    // 点击查看X位校友资源按钮后，更新数据
    updataIndustry() {
      this.alumnus = this.alumnusList;
      this.resourceShow = false;
      this.cityShow = false;
      this.searchShow = false;
    },
    clearIndustryList() {
      this.industryNameList.length = 0;
      console.log(this.industryNameList);
      const changeIndustryColor =
        document.getElementsByClassName("industryName");
      for (let i = 0; i < changeIndustryColor.length; i++) {
        changeIndustryColor[i].style.color = "#333333";
        changeIndustryColor[i].style.borderColor = "#BFBFBF";
      }
    },
    clearCityList() {
      this.cityNameList.length = 0;
      console.log(this.cityNameList);
      const changeCityColor = document.getElementsByClassName("cityName");
      for (let i = 0; i < changeCityColor.length; i++) {
        changeCityColor[i].style.color = "#333333";
        changeCityColor[i].style.borderColor = "#BFBFBF";
      }
    },
    showCityPopup() {
      this.resourceShow = false;
      this.cityShow = true;
      document.getElementById("resourcesId").style.color = "#00706E";
    },
    // 获取城市1级
    async getProvince() {
      const result = await this.$http.get("/amresources/getProvinceList");
      this.province = result.data.ProvinceList;
    },
    // 获取城市2级
    async getCity(item, name) {
      const result = await this.$http.get("/amresources/getCityList", {
        params: {
          CityList: item.substr(10),
        },
      });
      this.city = result.data.CityList;
      console.log(name);
      const changeColor = document.getElementsByClassName("province");
      for (let i = 0; i < changeColor.length; i++) {
        changeColor[i].style.color = "#333333";
      }
      document.getElementById(item).style.color = "#00706E";
    },
    clickCityName(id, name) {
      if (document.getElementById(id).style.color === "rgb(57, 135, 251)") {
        document.getElementById(id).style.color = "#333333";
        document.getElementById(id).style.borderColor = "#bfbfbf";
        for (let i = 0; i < this.cityNameList.length; i++) {
          if (this.cityNameList[i] === name) {
            this.cityNameList.splice(i, 1);
            i--;
            console.log(this.cityNameList);
            this.clickAndGetIndustryName();
          }
        }
      } else {
        this.cityNameList.push(name);
        console.log(this.cityNameList);
        this.clickAndGetIndustryName();
        document.getElementById(id).style.color = "#00706E";
        document.getElementById(id).style.borderColor = "#00706E";
      }
    },
    showSearchPopup() {
      this.searchShow = true;
    },
    // 清空.resetFields()
    clearFormData() {
      this.$refs.formData.resetFields();
    },
    getSearch() {
      this.$refs.formData.validate(async (valid) => {
        // 请求api之前的一个前端验证
        if (!valid) {
          return;
        }
        console.log(this.formData);
        const result = await this.$http.get(
          "/amresources/getAlumniInDetailList",
          {
            params: {
              city: this.cityNameList.toString(),
              industry: this.industryNameList.toString(),
              name: this.formData.name,
              sex: this.formData.sex,
              college: this.formData.college,
              major: this.formData.major,
              xuejie: this.formData.xuejie,
              xueli: this.formData.xueli,
              danwei: this.formData.danwei,
              hangye: this.formData.hangye,
              hobby: this.formData.hobby,
              userId: this.formData.userId,
              currentPage: 1,
              perPage: 5,
              bigShot: 0,
            },
          }
        );
        this.alumnusNum = result.data.list.length;
        this.alumnusList = result.data.list;
        this.updataIndustry();
      });
    },
    gotoAlumnusList(aUserId) {
      console.log(aUserId);
      return this.$router.push({
        path: "/alumniDetails",
        query: { 用户Id: aUserId },
      });
    },
    // 懒加载
    onLoad() {
      this.formData.currentPage = this.formData.currentPage + 1;
      this.getAlumnus();
      this.loading = false;
      // 数据全部加载完成
      if (this.formData.currentPage >= this.alumnusLastPage) {
        this.finished = true;
      }
    },
    async getMyCity() {
      let base64 = new Base64()
      const result = await this.$http.get("/my/getBasic", {
        params: {
          userId: base64.encode(this.formData.userId),
        },
      });
      this.myCity = result.data.city;
    },
  },
};
</script>
<style lang="less" scoped>
.alumniResourcesDiv {
  position: relative;
  left: 5%;
  width: 90vw;
}

.searchDiv {
  position: relative;
}

.resourcesDiv {
  float: left;
  position: absolute;
  left: 0%;
  padding-top: 5px;
}

.resources {
  background-color: #f5f5f5;
  font-size: 1.2em;
  color: #333333;
  font-weight: 600;
  padding: 0px;
  line-height: normal;
}

.cityDiv {
  float: left;
  position: absolute;
  left: 18%;
  padding-top: 5px;
}

.city {
  background-color: #f5f5f5;
  font-size: 1.2em;
  color: #333333;
  font-weight: 600;
  padding: 0px;
  line-height: normal;
}

.schoolFriends {
  float: left;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.schoolFriendsBtn {
  border: none;
  background-image: linear-gradient(to left, #00706e, #00706e);
  color: white;
  border-radius: 20px;
  font-size: 1em;
  padding: 8px 15px 8px 15px;
}

.search {
  float: right;
}

.searchPopupDiv {
  background-color: #f5f5f5;
  font-size: 1.2em;
  color: #333333;
  font-weight: 600;
  padding: 0px;
  line-height: normal;
}

.searchImg {
  width: 6.5vw;
  max-width: 50px;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.resourcesPopupSeach {
  position: relative;
  background-color: #f5f5f5;
  height: 8vw;
}

.provincePopupSeach {
  position: relative;
  background-color: #f5f5f5;
  height: 8vw;
}

.popupResources {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;
  font-size: 1.2em;
  font-weight: bold;
  color: #00706e;
}

.popupCity {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20%;
  font-size: 1.2em;
  font-weight: bold;
}

.provincePopupResources {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;
  font-size: 1.2em;
  font-weight: bold;
}

.provincePopupCity {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20%;
  font-size: 1.2em;
  font-weight: bold;
  color: #00706e;
}

.popupSearchDiv {
  position: absolute;
  right: 5%;
  float: left;
}

.popupData {
  height: 80%;
}

.popupDataResources {
  width: 35%;
  height: 100%;
  overflow-y: scroll;
  float: left;
}

.popupDataResources::-webkit-scrollbar {
  display: none;
}

.industry {
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  padding: 15px 0px 15px 0px;
  text-align: center;
  color: #333333;
  font-weight: bold;
}

.province {
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  padding: 15px 0px 15px 0px;
  text-align: center;
  color: #333333;
  font-weight: bold;
}

.industryNameDiv {
  position: relative;
  float: right;
  width: 65%;
  height: 100%;
  overflow-y: scroll;
}

.industryNameDiv::-webkit-scrollbar {
  display: none;
}

.industryName {
  position: relative;
  border: 1px solid #bfbfbf;
  width: 35%;
  float: left;
  text-align: center;
  padding: 2%;
  margin-top: 15px;
  left: 8%;
  margin-right: 4%;
  border-radius: 3px;
  color: #333333;
  font-size: 0.9em;
}

.cityNameDiv {
  position: relative;
  float: right;
  width: 65%;
  height: 100%;
  overflow-y: scroll;
}

.cityNameDiv::-webkit-scrollbar {
  display: none;
}

.cityName {
  position: relative;
  border: 1px solid #bfbfbf;
  width: 35%;
  float: left;
  text-align: center;
  padding: 2%;
  margin-top: 15px;
  left: 8%;
  margin-right: 4%;
  border-radius: 3px;
  color: #333333;
  font-size: 0.9em;
}

.btnDiv {
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  width: 100%;
  position: relative;
  height: 13%;
}

.clear {
  width: 35%;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #666666;
}

.getAlumniBtn {
  width: 60%;
  position: absolute;
  left: 35%;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px 0;
  border-radius: 20px;
  border: 0;
  color: white;
  background-image: linear-gradient(to left, #00706e, #00706e);
}

.searchPopup {
  border-radius: 0px !important;
}

.popSearchDataDiv {
  margin-top: 40px;
  width: 90%;
  position: relative;
  left: 5%;
}

.popSearchDataResourcesDiv {
  position: relative;
}

.popSearchDataResourcesName {
  float: left;
  font-size: 1.2em;
  font-weight: bold;
  padding: 20px 0px 20px 10px;
}

.popSearchDataResourcesNum {
  float: left;
  padding: 20px 0px 20px 0px;
  position: absolute;
  left: 85%;
}

.arrowResourcesDiv {
  float: right;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translateY(-50%);
}

hr {
  margin-block-start: 0;
  margin-block-end: 0;
  background-color: #bfbfbf;
  height: 1px;
  border: 0;
}

.popSearchDataCityDiv {
  position: relative;
}

.popSearchDataCity {
  float: left;
  font-size: 1.2em;
  font-weight: bold;
  padding: 20px 0px 20px 10px;
}

.popSearchDataCityNum {
  float: left;
  padding: 20px 0px 20px 0px;
  position: absolute;
  left: 85%;
}

.arrowCityDiv {
  float: right;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translateY(-50%);
}

.popSearchData {
  color: #00706e;
  font-size: 1.2em;
  font-weight: bold;
  padding: 20px 0px 20px 0px;
  height: 61vh;
  overflow: scroll;
}

.popSearchData::-webkit-scrollbar {
  display: none;
}

/deep/.el-form-item__label {
  color: #333333 !important;
  font-size: 1em !important;
  font-weight: bold;
  padding: 20px 0px 0px 10px;
}

/deep/.el-input__inner {
  border: 0;
  background-color: #f5f5f5;
  font-size: 1.1em !important;
  font-weight: normal;
  color: #999999 !important;
}

/deep/.el-form-item {
  margin-bottom: 0 !important;
}

.popSearchInput {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  line-height: 40px;
  padding-left: 15px;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
}

.sexSelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.dateSelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.educationSelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.industrySelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.searchBtnDiv {
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  width: 100%;
  position: relative;
  height: 8vh;
}

.clear {
  width: 35%;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #666666;
}

.alumniDivNav {
  position: relative;
  margin-top: 20px;
}

.ourSchool {
  float: left;
  font-size: 1.3em;
  width: 50%;
  text-align: center;
  background-color: #00706e;
  color: white;
  border-radius: 15px 0px 0px 0px;
  padding: 10px 0px 10px 0px;
}

.otherSchool {
  float: left;
  font-size: 1.3em;
  width: 50%;
  text-align: center;
  background-color: #dfdfdf;
  color: #999999;
  border-radius: 0px 15px 0px 0px;
  padding: 10px 0px 10px 0px;
}

.alumniDiv {
  background-color: white;
  padding-top: 20px;
  border-radius: 0px 0px 15px 15px;
  height: 80vh;
  overflow: scroll;
}

.alumniDiv::-webkit-scrollbar {
  display: none;
}

.ohterAlumniDiv {
  background-color: white;
  padding-top: 20px;
  border-radius: 0px 0px 15px 15px;
  height: 80vh;
  overflow: scroll;
}

.ohterAlumniDiv::-webkit-scrollbar {
  display: none;
}

.alumniCard {
  position: relative;
  left: 4%;
  width: 92%;
  background-color: #f5f5f5;
  border-radius: 15px;
  margin-bottom: 20px;
}

.alumniPhotoDiv {
  width: 25%;
  height: 20.7vw;
  float: left;
  padding: 10px;
  max-height: 200px;
  max-width: 200px;
}

.alumniPhoto {
  width: 100%;
  height: 100%;
  border-radius: 999px;
}

.sexDiv {
  position: absolute;
  left: 21%;
  top: 5%;
}

.sex {
  width: 22px;
  height: 22px;
}

.adress {
  text-align: center;
  font-size: 1em;
  color: #00706e;
  font-weight: 600;
}

.alumniData {
  float: left;
  width: 60%;
  padding-bottom: 10px;
}

.alumniName {
  padding-top: 10px;
  font-size: 1.2em;
  padding-bottom: 10px;
  color: #333333;
  font-weight: 600;
}

.alumniSchoolAndDissertation {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniIndustry {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniCompany {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniResources {
  margin: 2.5px 0px 2.5px 0px;
  color: #666666;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.van-cell {
  background-color: #f5f5f5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/alumniResources/AlumniResources.vue